import {Component} from "../interface/component";

export class HeaderScroll implements Component {
    private $body: JQuery;
    private $menu: JQuery;
    private $window: JQuery;

    private lastScrollTop: number = 0;
    protected didScroll: boolean;
    protected delta: number = 5;

    constructor(menu: HTMLElement) {
        this.$window = $(<any>window);
        this.$body = $('body');
        this.$menu = $(menu);
    }

    init() {
        this.$window.on('scroll.stickynav', () => {
            this.didScroll = true;
        });
        setInterval(() => {
            if (this.didScroll) {
                this.handleScroll();
                this.didScroll = false;
            }
        }, 250);

        this.setInitialState();
        
        // this.$window.on('scroll', () => this.handleScroll(false));
    }

    /**
     * @param onLoad Indicates whether this is being called on load or on scroll
     */

    handleScroll = () => {
        let scrollTop = this.$window.scrollTop();
        let navBarHeight = this.$menu.outerHeight();

        if (scrollTop > this.lastScrollTop && scrollTop > navBarHeight) {
            // scrolling down
            this.$menu.removeClass('l-header-bar--active');
            this.$menu.css('top', '-' + this.$menu.outerHeight() + 'px');
            this.$body.removeClass('l-page--scrolled');
        } else {
            // scrolling up
            this.$menu.addClass('l-header-bar--active');
            this.$menu.css('top', '0');
            if (scrollTop === 0) {
                this.$body.removeClass('l-page--scrolled');
            }
        }

        if (scrollTop < 60) {
            this.$menu.removeClass('l-header-bar--compact');
            this.$menu.removeClass('l-header-bar--active');
        } else {
            this.$menu.addClass('l-header-bar--compact');
        }
        this.lastScrollTop = scrollTop;
    }

    setInitialState = () => {
        this.handleScroll();
        setTimeout(() => { 
            this.$menu.addClass('l-header-bar--initialised');
        }, 300);
    }
}
